import { ReactElement } from "react";
import { twMerge } from "tailwind-merge";
import { Check } from "lucide-react";
import { Button } from "@shared/ui/Button";

export type Props = {
  className?: string;
  onClick?: () => void;
  checked?: boolean;
  children?: ReactElement<any> | ReactElement<any>[];
  disabled?: boolean;
  testId?: string;
};

export function DropdownButtonItem({
  className,
  children,
  checked,
  disabled,
  testId = "dropdown-button-item",
  onClick,
  ...rest
}: Props) {
  return (
    <Button
      variant="menu-item"
      className={twMerge(
        "justify-start w-full",
        checked && "bg-brand-100",
        className
      )}
      iconComponent={checked ? Check : undefined}
      data-testid={testId}
      disabled={disabled}
      onClick={onClick ? onClick : () => {}}
      {...rest}
    >
      {children}
    </Button>
  );
}

export default DropdownButtonItem;
